var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dataLoading),expression:"dataLoading"}],staticClass:"bg"},[_c('Preview',{directives:[{name:"show",rawName:"v-show",value:(!_vm.dataLoading),expression:"!dataLoading"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }